<template lang="html">
  <section class="wcc section prompt">
    <div class="wcc select">
      <div class="wcc add-to-homescreen-prompt">
        Like this app? Add it to your homescreen.
      </div>
    </div>
    <slot></slot>
  </section>
</template>
<script>
  export default {
  }
</script>
<style lang="scss">

  .wcc.section.prompt {
    background-color: white;
    .add-to-homescreen-prompt {
      margin: $spacing;
      text-align: center;
    }
  }

</style>